<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="costSummaryForm">
        <div class="my-section-box__headline">
        {{ 'common.airDiscBrake_value_calculator_brake_summary' | cxTranslate }}</div>
        <div class="my-section-box csaDowntime" id="csaDowntime">
          <div class="my-section-box-inner">
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="adbImpactWithImprovedStoppingDistance">
                  {{ 'common.airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance' | cxTranslate }}*
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-10 col-xs-10 col-sm-10 pr-0">
                    <select class="form-control" formControlName="adbImpactWithImprovedStoppingDistance">
                      @for (x of adbDropDownData; track x) {
                        <option [value]="x.code" (change)="calculateAndSetSum()">{{
                        x.name}}</option>
                      }
                    </select>
                  </div>
                  <div class="col-2 col-xs-2 col-sm-2 EndaTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_adbImpactWithImprovedStoppingDistance',
                                   'common.airDiscBrake_value_calculator_popup_adbImpactWithImprovedStoppingDistance')"
                        class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc Brake Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="initialADBFleetCost">
                  {{ 'common.airDiscBrake_value_calculator_initialAdbFleetCost' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="initialADBFleetCost" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="impactToFleetAccidentCosts">
                  {{ 'common.airDiscBrake_value_calculator_accidentcost' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="impactToFleetAccidentCosts" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                              'common.airDiscBrake_value_calculator_accidentcost',
                               'common.airDiscBrake_value_calculator_popup_impactToFleetAccidentCosts')"
                        class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc Brake Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="adbFrictionMileage">
                  {{ 'common.airDiscBrake_value_calculator_adbFriction' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="adbFrictionMileage" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.value_calculator_fleet_miles' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_adbFriction',
                                   'common.airDiscBrake_value_calculator_popup_adbFrictionMileage')" class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc Brake Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
            </div>
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="noOfPadReplacementsAtTradeIn">
                  {{ 'common.airDiscBrake_value_calculator_noOfPadReplacementsAtTradeIn' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="noOfPadReplacementsAtTradeIn" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.airDiscBrake_value_calculator_replacementCycle' | cxTranslate }}
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="noOfRotarReplacementsAtTradeIn">
                  {{ 'common.airDiscBrake_value_calculator_noOfRotarReplacementsAtTradeIn' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="noOfRotarReplacementsAtTradeIn" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.airDiscBrake_value_calculator_replacementCycle' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_noOfRotarReplacementsAtTradeIn',
                                   'common.airDiscBrake_value_calculator_popup_noOfRotarReplacementsAtTradeIn')"
                        class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc Brake Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
            </div>
            <div class="row  col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="padAndRotarReplacementUnitCost">
                  {{ 'common.airDiscBrake_value_calculator_padandRotarReplacementUnitCost' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="padAndRotarReplacementUnitCost" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.airDiscBrake_value_calculator_usd_unit' | cxTranslate }}
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="lifecyclePadAndRotarReplacementFleetCosts">
                  {{ 'common.airDiscBrake_value_calculator_lifeCyclePadAndRotarReplacementFleetCosts' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="lifecyclePadAndRotarReplacementFleetCosts" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row  col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="adbBrakeAdjustmentMaintanaceFleetCost">
                  {{ 'common.airDiscBrake_value_calculator_adbBrakeAdjustmentMaintanaceFleetCost' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="adbBrakeAdjustmentMaintanaceFleetCost" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                          'common.airDiscBrake_value_calculator_adbBrakeAdjustmentMaintanaceFleetCost',
                           'common.airDiscBrake_value_calculator_popup_adbBrakeAdjustmentMaintanaceFleetCost')"
                        class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc Brake Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="csaViolationFleetCost">
                  {{ 'common.airDiscBrake_value_calculator_csaViolationFleetCost' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="csaViolationFleetCost" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_csaViolationFleetCost',
                                   'common.airDiscBrake_value_calculator_popup_csaViolationFleetCost')"
                        class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc Brake Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
            </div>
            <div class="row  col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="adbRustJackingPadReplacementFleetCost">
                  {{ 'common.airDiscBrake_value_calculator_adbRustJackingPadReplacementFleetCost' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="adbRustJackingPadReplacementFleetCost" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                          'common.airDiscBrake_value_calculator_adbRustJackingPadReplacementFleetCost',
                           'common.airDiscBrake_value_calculator_popup_adbRustJackingPadReplacementFleetCost')"
                        class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc Brake Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="totalAdbUnitCost">
                  {{ 'common.airDiscBrake_value_calculator_totalAdbUnitCost' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="number" formControlName="totalAdbUnitCost" readonly appNumberFormat />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.airDiscBrake_value_calculator_usd_unit' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row  col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="totalADBFLeetCost">
                  {{ 'common.airDiscBrake_value_calculator_totalAdbFleetCost' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="totalADBFLeetCost" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.text_smartire_usd' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row col-12">
              <div class="paragraph-Summary">
                <ol>
                  <li>{{ 'common.airdiscBrake_value_calculator_cost_summary' | cxTranslate }}<br>{{
                  'common.airdiscBrake_value_calculator_cost_line' | cxTranslate }}</li>
                  <li>{{ 'common.airdiscBrake_value_calculator_cost_secondsummary' | cxTranslate }}</li>
                  <li>{{ 'common.airdiscBrake_value_calculator_cost_thirdsummary' | cxTranslate }}</li>
                </ol>
              </div>
            </div>
            <div class="airdisk-button-block">
              <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn"
                (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow" alt="Back">
              {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
              <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn"
                (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                <img src="/icons/link-right-white.svg" class="right-arrow" alt="Next"></button>
              </div>
            </div>
          </div>
        </form>
      }
    </div>
  </div>